import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", as: Tag = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.85, delay, ease: EASE }}
    >
      {children}
    </MotionTag>
  );
};

export const Stagger = ({ children, className = "", step = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-70px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: step } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 22 }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0 } }}
    transition={{ duration: 0.7, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal used for the hero and manifesto headings.
export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, step = 0.13 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? false : { y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: delay + i * step, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export { EASE };
